import { CheckboxProps as MantineCheckboxProps } from "@mantine/core";
import { Checkbox as MantineCheckbox } from "@mantine/core";
import classes from "./index.module.css";
import CheckedIcon from "@/components/Controls/Checkbox/CheckedIcon";
import { ControlsWrapper } from "@/components/Controls/ControlsWrapper";

interface CheckboxProps extends MantineCheckboxProps {
  helperLabel?: string;
}

export const Checkbox = ({ helperLabel = "", ...checkboxProps }: CheckboxProps) => {
  return (
    <ControlsWrapper size={checkboxProps.size} helperLabel={helperLabel}>
      <MantineCheckbox
        {...checkboxProps}
        icon={CheckedIcon}
        classNames={{
          ...classes,
          ...checkboxProps.classNames,
        }}
      />
    </ControlsWrapper>
  );
};
